import { FC, ReactNode } from 'react';

export type LabelProps = {
  children: ReactNode;
  tooltip?: string;
};

export const Label: FC<LabelProps> = ({
  children,
  tooltip
}) => {
  return (
    <label>
      {children}
      {(!tooltip) ? null : (
        <span data-tip={tooltip}>
          <i className="fe icon-info"/>
        </span>
      )}
    </label>
  );
};
